import { TitleEntityForm } from '../../features/TitleEntityForm';
import { apiRequests } from '../../shared/api/apiRequests';

const EditIndustryPage = () => (
  <TitleEntityForm
    load={apiRequests.portfolio.getIndustry}
    update={apiRequests.portfolio.updateIndustry}
    backTo="/portfolio/industries"
    savedText="Индустрия сохранена"
  />
);

export default EditIndustryPage;
